import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FullScreenService {
	escapeAttempt$ = new Subject<void>();
	private listening = false;

	private fullscreenHandler = () => {
		if (!document.fullscreenElement) {
			this.escapeAttempt$.next();
		}
	};


	async enterFullscreen(): Promise<void> {
		const el = document.documentElement;

		try {
			const request =
				el.requestFullscreen ||
				(el as any).webkitRequestFullscreen ||
				(el as any).mozRequestFullScreen ||
				(el as any).msRequestFullscreen;

			if (request) {
				await request.call(el);
			}
		} catch (err) {
			console.warn('Fullscreen request failed:', err);
		}
	}


	exitFullscreen(): void {
		const exit =
			document.exitFullscreen ||
			(document as any).webkitExitFullscreen ||
			(document as any).mozCancelFullScreen ||
			(document as any).msExitFullscreen;

		if (exit) {
			exit.call(document);
		}
	}


	listenForExit(): void {
		if (this.listening) return;

		this.listening = true;

		document.addEventListener('fullscreenchange', this.fullscreenHandler);
		document.addEventListener('webkitfullscreenchange', this.fullscreenHandler as any);
	}


	cleanup(): void {
		this.listening = false;

		document.removeEventListener('fullscreenchange', this.fullscreenHandler);
		document.removeEventListener('webkitfullscreenchange', this.fullscreenHandler as any);
	}


	isFullscreen(): boolean {
		return !!(
			document.fullscreenElement ||
			(document as any).webkitFullscreenElement
		);
	}



}